import { Component } from "react";
import InputGroup from "./InputGroup";
import Select from "./Select";
import { handleFormikValueChange } from "../../utils";

type OwnProps = {
  name?: string;
  handleChange?: $TSFixMeFunction;
  disabled?: boolean;
  isSubmitting?: boolean;
  labelKey?: string;
  values?: $TSFixMe;
  renderOption?: $TSFixMeFunction;
  input?: $TSFixMe;
  onChange?: $TSFixMeFunction;
};

const defaultProps: Partial<OwnProps> = {
  labelKey: "name",
};

type Props = OwnProps & typeof defaultProps;

class SelectBox extends Component<Props> {
  static readonly defaultProps = defaultProps;

  constructor() {
    // @ts-expect-error TS(2554) FIXME: Expected 1-2 arguments, but got 0.
    super();
    /* istanbul ignore next */
    this.renderOption = this.renderOption.bind(this);
  }

  renderOption(option: $TSFixMe) {
    const { labelKey } = this.props;
    const verified =
      option.tenantName && option.tenantPublic ? (
        <span className="select-option-icon">
          <span className="icon icon3-eh-radio-button-checked" />
        </span>
      ) : null;
    const tenant =
      option.tenantName && !option.tenantPublic
        ? ` (${option.tenantName})`
        : null;
    return (
      <div>
        {/* @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type. */}
        <span className="select-option-value">{option[labelKey]}</span>
        {tenant}
        {verified}
      </div>
    );
  }

  render() {
    const {
      name,
      values,
      disabled,
      isSubmitting,
      renderOption,
      input,
      onChange,
    } = this.props;
    const props = { ...this.props }; // React: Spread children are not supported in React
    // redux form
    if (input) {
      return (
        <InputGroup {...props}>
          <Select
            {...props}
            disabled={disabled || isSubmitting}
            onChange={input.onChange}
            // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
            selectedOption={values && values[name]}
            renderOption={renderOption || this.renderOption}
          />
        </InputGroup>
      );
      //  FORMIK
    }
    return (
      <InputGroup {...props}>
        <Select
          {...props}
          disabled={disabled || isSubmitting}
          onChange={
            onChange || ((value) => handleFormikValueChange(this.props, value))
          }
          selectedOption={
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            values && name.split(".").reduce((p, c) => p?.[c], values)
          }
          renderOption={renderOption || this.renderOption}
        />
      </InputGroup>
    );
  }
}

export default SelectBox;
